import { SECURITY_API_URL } from "../environment";
import { initAxiosFor } from "../security/axiosUtils";

export type CreateLink = {
  name: string;
  url: string;
  userProfileId: string;
}

export type Link = CreateLink & {
  id: string;
  token: string;
}

export function initLinkService() {
  const axiosInstance = initAxiosFor(SECURITY_API_URL);

  const getLinks = async (): Promise<Link[]> => {
    return (await axiosInstance?.get(`/api/link`))?.data;
  }

  const getLinkById = async (id: string): Promise<Link> => {
    return (await axiosInstance?.get(`/api/link/${id}`))?.data;
  }

  const createLink = async (link: CreateLink): Promise<Link> => {
    return (await axiosInstance?.post(`/api/link`, link))?.data;
  }

  const updateLink = async (id: string, link: CreateLink): Promise<Link> => {
    return (await axiosInstance?.put(`/api/link/${id}`, link))?.data;
  }

  const updateLinkToken = async (id: string): Promise<Link> => {
    return (await axiosInstance?.put(`/api/link/${id}/token`))?.data;
  }

  return {
    getLinks,
    getLinkById,
    createLink,
    updateLink,
    updateLinkToken,
  };
}
